import { H3 } from '@berlitz/globals'
import Checkbox from '@components/Checkbox'
import { TProfile } from '@interfaces/MyLesson'
import isArray from 'lodash/isArray'
import map from 'lodash/map'
import * as React from 'react'
import { FormattedMessage, InjectedIntlProps, injectIntl } from 'react-intl'
import { Col, Row } from 'react-styled-flexboxgrid'
import GroupProfile from './GroupProfile'
import { StudyPurposeProp } from './interface'
import {
  // StyledCol,
  // ProfileLabel,
  // ProfileValue,
  Container,
  StyledButton,
  StyledButtonCol,
  NoPaddingCol,
} from './style'

const StudyPurpose: React.FC<StudyPurposeProp & InjectedIntlProps> = ({
  profiles,
  groupName,
  groupId,
  showLearningProfile,
}) => (
  <>
    {!isArray(profiles) && (
      <>
        <Row>
          <NoPaddingCol xs={12} md={12}>
            <H3 className="margin-bottom-20">
              <FormattedMessage id="Purpose of study" />
            </H3>
          </NoPaddingCol>
          <NoPaddingCol xs={12} md={12}>
            {profiles.Purpose}
          </NoPaddingCol>
        </Row>
        {/*
            <Container>
              <Row>
                <Col xs={12} md={12}>
                  <H3>
                    <FormattedMessage id="Profile details" />
                  </H3>
                </Col>
                <Col xs={12} md={12}>
                  <Row>
                    <StyledCol md={4}>
                      <ProfileLabel>
                        <FormattedMessage id="Employment" />
                      </ProfileLabel>
                      <ProfileValue>{profiles.Employment}</ProfileValue>
                    </StyledCol>
                    <StyledCol md={4}>
                      <ProfileLabel>
                        <FormattedMessage id="Experience Abroad" />
                      </ProfileLabel>
                      <ProfileValue>{profiles.ExperienceAbroad}</ProfileValue>
                    </StyledCol>
                    <StyledCol md={4}>
                      <ProfileLabel>
                        <FormattedMessage id="Hobbies" />
                      </ProfileLabel>
                      <ProfileValue>{profiles.Hobbies}</ProfileValue>
                    </StyledCol>
                  </Row>
                </Col>
              </Row>
            </Container>
          */}

        <Container>
          <Row>
            <NoPaddingCol xs={12} md={12}>
              <H3 className="margin-bottom-20">
                <FormattedMessage id="Lesson expectations" />
              </H3>
            </NoPaddingCol>
            {map(profiles.Expectations, (expectation, index) => (
              <Col xs={12} md={12} key={index}>
                <Checkbox
                  checked={true}
                  disabled
                  label={expectation}
                  name={expectation}
                  value={expectation}
                  field={{
                    name: expectation,
                  }}
                />
              </Col>
            ))}
          </Row>
        </Container>

        <Row>
          <StyledButtonCol sm={12} md={12}>
            <div>
              <StyledButton outline onClick={showLearningProfile}>
                <FormattedMessage id="Learning profile" />
              </StyledButton>
            </div>
          </StyledButtonCol>
        </Row>
      </>
    )}

    {isArray(profiles) && (
      <GroupProfile
        profiles={profiles as TProfile[]}
        groupName={groupName}
        groupId={groupId}
        showLearningProfile={showLearningProfile}
      />
    )}
  </>
)

export default injectIntl(StudyPurpose)
